import './App.sass';
import { ChatBot } from './ChatBot';
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MapView from './MapView';
import type { AppShellContext } from './components/AppShell';


interface Properties {
  tenant?: string;
}

export default function ChatBotPage(_properties: Properties) {
  const { t } = useTranslation();
  const { setTitle } = useOutletContext<AppShellContext>();
  const [selectedResource, setSelectedResource] = useState(null) as any;

  const resourceSelected = (resource: any) => {
    console.log('======> resourceSelected', resource);
    setSelectedResource(resource);
  }

  // Der Chat läuft im AppShell: Kopfzeile, Sidebar-Rahmen und Übergang kommen
  // von dort, der Titel wird wie auf den anderen Seiten über den
  // Outlet-Context gesetzt. Das Kundenlogo sitzt im Sidebar-Kopf; Einstellungen,
  // Administration und Abmelden hängen im Avatar-Kontomenü des SiteHeader.
  useEffect(() => {
    setTitle(t('header.assistant'));
  }, [setTitle, t]);

  return (
    <>
      {selectedResource
        ?
        // Der Kartenblick ersetzt wie bisher die ganze Seite. MapView misst
        // selbst 100vw/100vh und brächte im Shell-Inset doppelte Scrollbalken —
        // er liegt deshalb als Vollbild über Kopfzeile und Sidebar.
        <div className="fixed inset-0 z-50 overflow-hidden bg-background">
          <MapView resource={selectedResource} resetResource={() => setSelectedResource(null)}></MapView>
        </div>
        :
        <ChatBot selectedResource={selectedResource} resourceSelected={resourceSelected}>
        </ChatBot>
      }
    </>
  );
}
